import strFunc from "@/lib/lyg/string";
import React from "react";
import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";

function MessageListArea(props: any) {
  let myProps = {
    Style: {},
    order_info_arr: [],
    set_order_info_arr: (inData: any) => { },
    katalk_template_info: {},
    ...props
  };
  let Style = myProps.Style;
  let order_info_arr = myProps.order_info_arr;
  let katalk_template_info = myProps.katalk_template_info;
  let input_col_arr: any = [];//{name:""}
  if (katalk_template_info && katalk_template_info.a_templete_vars_json) {
    for (let i = 0; i < katalk_template_info.a_templete_vars_json.length; i++) {
      let var_info = katalk_template_info.a_templete_vars_json[i];
      let key_str = var_info.key;
      key_str = key_str.replaceAll("{", "").replaceAll("}", "");
      key_str = key_str.replaceAll("#", "");
      input_col_arr.push({ name: key_str, orin_key: var_info.key });
    }
  }

  const on_change_msg_json = (inData: any) => {
    let opt_obj = {
      order_info: null,
      name: "",
      value: "",
      ...inData
    };
    let order_info = opt_obj.order_info;
    let name = opt_obj.name;
    let value = opt_obj.value;

    if(name=="phone_num"){
      value=strFunc.autoHypenPhone(value);
    }

    let change_send_msg_json = { ...order_info.send_msg_json };
    change_send_msg_json[name] = value;

    let row_num = -1;
    for (let i = 0; i < order_info_arr.length; i++) {
      if (order_info_arr[i].row_pri_val === order_info.row_pri_val) {
        row_num = i;
      }
    }
    if (row_num === -1) {
      return;
    }

    order_info.send_msg_json = change_send_msg_json;
    let change_order_info_arr = [...order_info_arr];
    change_order_info_arr[row_num] = order_info;
    myProps.set_order_info_arr(change_order_info_arr);
  };

  const update_phone_num_of_comp_by_ajax = (inData: any) => {
    let opt_obj = {
      order_info: null,
      phone_num: "",
      ...inData
    };
    let order_info = opt_obj.order_info;
    let phone_num = opt_obj.phone_num;
    if (strFunc.is_empty(order_info.mcomp_addon)) {
      return;
    }
    if (strFunc.is_empty(order_info.mcomp_addon.row_pri_val)) {
      return;
    }
    let change_comp_addon = {
      a_mcomp_seq: order_info.mcomp_addon.a_mcomp_seq,
      a_responser_phone: phone_num
    };
    let form_json_data: any = {
      data_arr: [change_comp_addon],
      is_update: "1"
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp_addon/write',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {

        } else {
          alert("전화번호 업데이트에 실패하였습니다.");
        }
      });
  }

  const get_templete_content_str_msg = (inData: any) => {
    let opt_obj = {
      order_info: null,
      ...inData
    };
    let order_info = opt_obj.order_info;

    let msg_str: any = katalk_template_info.a_templete_content;
    for (let col_i = 0; col_i < input_col_arr.length; col_i++) {
      let col_info = input_col_arr[col_i];
      let col_key = col_info.name;
      let col_row_val = "";
      if (order_info.send_msg_json[col_key]) {
        col_row_val = order_info.send_msg_json[col_key];
      }

      msg_str = msg_str.replaceAll(col_info.orin_key, col_row_val);
    }

    return msg_str;
  };

  const get_msg_list_tags = () => {
    let list_tags = order_info_arr.map((order_info: any, order_idx: number) => {
      return (
        <React.Fragment key={order_idx} >
          <tr>
            <td className={Style.no_cell}>{order_idx + 1}</td>
            {input_col_arr.map((col_info: any, col_idx: number) => {
              let col_row_val = "";
              let col_key = col_info.name;
              if (order_info.send_msg_json[col_key]) {
                col_row_val = order_info.send_msg_json[col_key];
              }
              return (
                <td key={col_idx}>
                  <input type="text" value={col_row_val}
                    name={col_key}
                    className={Style.col_input}
                    onChange={(e: any) => {
                      on_change_msg_json({
                        order_info: order_info,
                        name: e.target.name,
                        value: e.target.value,
                      });
                    }}
                  />
                </td>
              );
            })}
            <td>
              <input type="text" value={order_info.send_msg_json.phone_num}
                name={"phone_num"}
                className={Style.col_input}
                onChange={(e: any) => {
                  on_change_msg_json({
                    order_info: order_info,
                    name: e.target.name,
                    value: e.target.value,
                  });
                }}
                onBlur={() => {
                  update_phone_num_of_comp_by_ajax({
                    order_info: order_info,
                    phone_num: order_info.send_msg_json.phone_num
                  });
                }}
              />
            </td>
          </tr>
          <tr>
            <td colSpan={99} className={Style.msg_preview_td}>
              <div className={Style.msg_preview_box}>
                <MultyLineTextView text={get_templete_content_str_msg({ order_info: order_info })} />
              </div>
            </td>
          </tr>
        </React.Fragment>
      );
    });

    if (strFunc.is_empty(list_tags)) {
      return (
        <tr>
          <td colSpan={99} style={{ textAlign: "center", padding: "20px", color: "#9ca3af" }}>메세지 내역이 없습니다.</td>
        </tr>
      );
    }

    return list_tags;
  };

  return (
    <div>
      <div className={Style.section_title}>메세지 내역</div>
      <div className={Style.table_wrap}>
        <table className={Style.list_table}>
          <colgroup></colgroup>
          <thead>
            <tr>
              <th>No.</th>
              {input_col_arr.map((col_info: any, col_idx: number) => {
                return (
                  <th key={col_idx}>
                    {col_info.name}
                  </th>
                );
              })}
              <th>받는번호</th>
            </tr>
          </thead>
          <tbody>
            {get_msg_list_tags()}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default MessageListArea;